<template>
  <div
    class="signup-container"
    :class="{
      mob: $vuetify.display.smAndDown,
      desk: !$vuetify.display.smAndDown,
    }"
  >
    <div class="left">
      <div class="logo">
        <v-img
          width="30"
          :src="require('@/assets/logo/logo_dark.svg')"
          contain
        ></v-img>
      </div>

      <div
        class="sub-container form"
        :style="{
          width: $vuetify.display.smAndDown ? '80%' : '60%',
          paddingBottom: $vuetify.display.smAndDown ? '0' : '130px',
          marginTop: $vuetify.display.smAndDown ? '30px' : '130px',
        }"
      >
        <div v-if="userProfile && userProfile.workspace">
          <v-btn
            size="small"
            class="mb-4"
            variant="text"
            @click="$router.back()"
            ><v-icon size="small" class="mr-2">mdi-arrow-left</v-icon>Back to
            dashboard</v-btn
          >
        </div>
        <p style="font-size: 8pt; margin-bottom: 5px">Progress</p>
        <v-progress-linear
          class="mb-4"
          color="faded"
          rounded
          :model-value="step * 25"
        >
        </v-progress-linear>

        <v-window v-model="step">
          <v-window-item :value="1">
            <div>
              <h1
                :style="{
                  fontSize: $vuetify.display.smAndDown ? '35px' : '40px',
                }"
              >
                Let's create your workspace
              </h1>
              <p class="my-2">
                Your workspace is where you will create, review, publish and
                edit all your social media activities, together with your
                colleagues.
              </p>
              <v-text-field
                class="mb-2 mt-4"
                variant="solo"
                placeholder="Workspace name.."
                flat
                v-model="workspace"
                hide-details=""
                :style="{
                  borderBottom: '2px solid #272727',
                  borderLeft: '1px solid #272727',
                  borderTop: '1px solid #272727',
                  borderRight: '2px solid #272727',
                  borderRadius: '5px',
                }"
                @keyup.enter="workspace ? (step = 2) : null"
              ></v-text-field>

              <v-btn
                height="50"
                elevation="0"
                color="button"
                class="mt-4 px-6"
                @click="step = 2"
                :disabled="!workspace"
              >
                Continue
                <v-icon size="small" class="ml-2">mdi-arrow-right</v-icon>
              </v-btn>
            </div>
          </v-window-item>

          <v-window-item :value="2">
            <div>
              <h1
                :style="{
                  fontSize: $vuetify.display.smAndDown ? '35px' : '40px',
                }"
              >
                About {{ workspace }}?
              </h1>
              <div class="options mt-4">
                <v-select
                  label="How big is your company?"
                  :items="sizes"
                  v-model="company_size"
                  hide-details=""
                  variant="solo"
                  bg-color="smoke"
                  flat
                  class="mb-4"
                ></v-select>
                <v-text-field
                  label="What is your company's website?"
                  v-model="website"
                  hide-details=""
                  class="mb-4"
                  variant="solo"
                  bg-color="smoke"
                  flat
                  @keyup.enter="website && company_size ? (step = 3) : null"
                ></v-text-field>
                <!-- <p style="font-size: 10px" class="mt-4 mb-2">
                  Which country & timezone is your business located?
                </p> -->
                <div>
                  <v-autocomplete
                    :menu-props="{ offsetY: true }"
                    label="Which country & timezone is your business located?"
                    v-model="country"
                    :items="sorted_countries"
                    item-title="name"
                    return-object
                    variant="solo"
                    hide-details=""
                    flat
                    bg-color="smoke"
                    style="border-radius: 8px"
                    @update:model-value="checkTZ"
                  ></v-autocomplete>
                  <v-autocomplete
                    class="mt-2"
                    v-if="country && country?.zones?.length > 1"
                    :menu-props="{ offsetY: true }"
                    label="Timezone"
                    v-model="timezone"
                    :items="country.zones"
                    item-title="name"
                    variant="solo"
                    hide-details=""
                    flat
                    bg-color="smoke"
                    style="border-radius: 8px"
                  ></v-autocomplete>
                </div>
              </div>
              <v-btn
                height="50"
                elevation="0"
                color="button"
                class="mt-4 px-6"
                @click="step = 3"
                :disabled="!website || !company_size || !country || !timezone"
              >
                Continue
                <v-icon size="small" class="ml-2">mdi-arrow-right</v-icon>
              </v-btn>
            </div>
          </v-window-item>

          <v-window-item :value="3">
            <div>
              <h1
                :style="{
                  fontSize: $vuetify.display.smAndDown ? '35px' : '40px',
                }"
              >
                Let's invite your colleagues
              </h1>
              <div class="mt-2" v-for="(i, index) in invites" :key="index">
                <v-text-field
                  v-model="i.email"
                  class="mb-2 mt-2"
                  variant="solo"
                  placeholder="name@yourcompany.com"
                  flat
                  hide-details=""
                  :style="{
                    borderBottom: '2px solid #272727',
                    borderLeft: '1px solid #272727',
                    borderTop: '1px solid #272727',
                    borderRight: '2px solid #272727',
                    borderRadius: '5px',
                  }"
                ></v-text-field>
              </div>

              <v-btn
                elevation="0"
                class="mb-4 mt-2"
                variant="tonal"
                @click="invites.push({ email: '' })"
                ><v-icon>mdi-plus</v-icon></v-btn
              >
              <div class="d-flex" style="gap: 10px">
                <v-btn
                  height="50"
                  elevation="0"
                  color="button"
                  class="mt-4 px-6"
                  :disabled="!invites[0].email"
                  @click="createWorkspace(false)"
                >
                  Invite & Continue
                  <v-icon size="small" class="ml-2">mdi-arrow-right</v-icon>
                </v-btn>
                <v-btn
                  @click="createWorkspace(true)"
                  variant="text"
                  height="50"
                  class="mt-4"
                  >Skip & continue</v-btn
                >
              </div>
            </div>
          </v-window-item>
        </v-window>
      </div>
    </div>
    <div class="button" v-if="!$vuetify.display.smAndDown"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { timezones } from "@/mixins/timezones";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";

export default {
  computed: {
    ...mapState({
      loading: (state) => state.loading,
      userProfile: (state) => state.users.userProfile,
    }),
    sorted_countries() {
      let list = this.countries;
      list.sort((a, b) => (a.name < b.name ? -1 : b.name < a.name ? 1 : 0));
      return list;
    },
  },
  mixins: [timezones],
  async mounted() {
    const getWaitingListData = httpsCallable(functions, "getWaitingListData");
    const res = await getWaitingListData();
    console.log(res.data);
    if (res.data) {
      this.brand = res.data;
    }
  },
  data() {
    return {
      brand: null,
      voice: null,
      company_size: "",
      country: null,
      description: "",
      audience: "",
      product: "",
      email: "",
      invites: [
        {
          email: "",
          role: "",
          invited: true,
        },
        {
          email: "",
          role: "",
          invited: true,
        },
      ],
      goals: [],
      first_name: "",
      last_name: "",
      job_title: "",
      keywords: [],
      overlay: false,
      password: "",
      referral: null,
      reset_email: "",
      reset_sent: false,
      sizes: ["Just me", "2 - 10", "11 - 50", "51 - 200", "200+"],
      step: 1,
      timezone: null,

      website: "",
      workspace: "",
      waiting_list: null,
    };
  },
  methods: {
    checkTZ(v) {
      console.log(v);
      this.timezone = v.zones[0];
    },
    async createWorkspace(skip) {
      this.overlay = true;

      let workspace = {
        invites: this.invites,
        first_name: this.first_name,
        uid: this.userProfile.uid,
        timezone: this.timezone,
        country: this.country,
        type: "company",
        name: this.workspace,
        referral: this.referral,
        skip: skip,
        brand: { ...this.brand, website: this.website },
      };
      await this.$store.dispatch("createWorkspace", workspace);
      this.overlay = false;
    },
  },
};
</script>

<style scoped lang="scss">
.signup-container {
  height: 100vh;
  background-color: white;

  &.desk {
    display: grid;
    grid-template-columns: 1fr;
  }

  .left {
    display: grid;
    grid-template-rows: 100px auto;

    .logo {
      display: flex;
      gap: 8px;
      width: 100px;
      align-items: center;
      padding-left: 30px;
    }

    .sub-container {
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      max-width: 450px;

      &.form {
        justify-content: flex-start;
      }

      &.reset {
        display: block;
      }

      &.signin {
        justify-content: center;
      }

      .steps {
        display: flex;
        gap: 10px;
        margin-bottom: 30px;
      }

      .login-buttons {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        gap: 15px;

        .or {
          display: grid;
          grid-template-columns: 1fr 220px 1fr;
          align-items: center;
          text-align: center;
          margin: 25px 0;
        }

        .email {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }
      }
      .sent {
        display: grid;
        grid-template-columns: auto 60px;
        grid-template-rows: 1fr 50px;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
}
.animate__animated.animate__slideInRight {
  --animate-duration: 0.5s;
}
</style>
